import { createFileRoute } from '@tanstack/react-router'
import BlocksTableContainer from '../components/BlocksTableContainer'

export const Route = createFileRoute('/blocks')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div>
      <BlocksTableContainer />
    </div>
  )
}
